$(document).ready(function(){

//set default first tag value
$(".variant-tags").each(function(){
 var default_label = $(this).val();
 //console.log(default_label);
  if($(this).attr('checked')){
    var defvalue = $(this).val();
    //console.log(defvalue);
    $("span#var_tag_main").html(defvalue);
  }
})

var scroll = $(window).scrollTop();;
  
$(window).on("scroll",function(){
    scroll = $(this).scrollTop();
});

// set according to selection
$("variant-radios.no-js-hidden.product-var-tags fieldset.js.product-form__input label").click(function(){
  var label = $(this).html();
  //console.log(label);
  $("span#var_tag_main").html(label);

});
  
  
$("button.thumbnail").on("click", function(e){ 
  var s = scroll;
  var getid = $(this).attr("varid");
  $("label[varid='"+getid+"']").trigger("click");
  if($(window).width() < 750)
  {
  	window.scrollTo(0, s);
  }
})

$(".slider-button--next").attr("data-step",1);
$(".slider-button--prev").attr("data-step", 1);  

$(".slider-button--next").on("click",function(e){
 $(".thumbnail[aria-current='true']").parent("li").next("li").find("button").trigger("click");
// $("li[data-media-position='"+next+"'] button").trigger("click"); 
  
});
  
$(".slider-button--prev").on("click",function(){ 
 $(".thumbnail[aria-current='true']").parent("li").prev("li").find("button").trigger("click");
// $("li[data-media-position='"+next+"'] button").trigger("click"); 
  
});  

 $(document).on("click",".custom-variant-trigger",function(){
  const trigger = $(this).attr("option-drawer-id");
  $("."+trigger).addClass("active");
 });

 $(document).on("click",".custom-variant-drawer-close,.custom-variant-drawer-overlay",function(){
  $(this).parents(".custom-variant-drawer").removeClass("active");
 });

 $(document).on("click",".custom-variant-drawer-overlay",function(){
  $(this).siblings(".custom-variant-drawer").removeClass("active");
 });
  
 $(document).on("click",".custom-variant-drawer-content-item",function(){
   const label = $(this).attr("data-opt");
   if(label != '')
   {
     const variantRadio = $(this).parents(".custom-drawer-outer").siblings("variant-radios");
     variantRadio.find('input[value="'+label+'"]').trigger("click");
     $(".custom-variant-selected-option").html(label);
     $(".var-tag-main").html(label);
     $(this).siblings(".custom-variant-drawer-content-item").removeClass("active");
     $(this).addClass("active");
     $(this).parents(".custom-variant-drawer").removeClass("active");
   }
 });
});

// start BSS fix css for register page
if (window.location.pathname.includes("/pages/")) {
  setTimeout(() => {
    $('#RegisterForm input:not([type="checkbox"]):not([type="file"]):not(.country-field):not([type="hidden"]):not([type="submit"])').each((_, input) => {
      $(input).attr("placeholder", " ");
      let label = $(input).parent().find('label')
      if (label.length == 0) label = $(input).parent().parent().find('label')
      $(input).parent().css("position", "relative")
      $(input).after(label)
    })
    $("#company-field").removeAttr("disabled")
  }, 200)
}
// end BSS fix css for register page


